exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo__wrapper{text-align:center}.v-content{padding-top:0!important}.logo__wrapper>img{height:100px!important}#login--alert{text-align:center;border-width:0!important;color:red}#changePasswordBtn{padding-left:10px}#login-btn{float:right;margin-right:5px}#submit-btn{margin-bottom:20px;margin-right:0}.logo__wrapper--desc{display:flex;text-align:center}.logo__wrapper--desc p{color:rgba(0,0,0,.7);font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fb07e36","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/login/Login.vue
// module id = 1072
// module chunks = 0